import { RotateGizmo } from 'playcanvas';

import { TransformTool } from './transform-tool';
import { configureAxisOnlyRotateGizmo } from './rotate-gizmo-config';
import { Events } from '../events';
import { Scene } from '../scene';

class RotateTool extends TransformTool {
    constructor(events: Events, scene: Scene) {
        const gizmo = new RotateGizmo(scene.camera.camera, scene.gizmoLayer);
        gizmo.rotationMode = 'orbit';
        configureAxisOnlyRotateGizmo(gizmo);

        super(gizmo, events, scene);
    }
}

export { RotateTool };
